import { useEffect } from 'react'

import Timer from '../Utils/Timer'

import clsx from 'clsx'
import s from './ToastItem.module.scss'

function ToastItem({ id, type, message, duration, onExpire, onRemove }) {
  const ownTimer = new Timer(() => {
    onExpire()
  }, duration)

  useEffect(() => {
    ownTimer.resume()
  }, [ownTimer])

  const handleOnMouseEnter = () => {
    ownTimer.pause()
  }

  const handleOnMouseLeave = () => {
    ownTimer.resume()
  }

  return (
    <div
      className={clsx(s.toast, s[type])}
      key={id}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      {message}
      {/* <button onClick={onRemove}>remover</button> */}
    </div>
  )
}

export default ToastItem
